/**
 * Centralised TanStack Query keys for the Categories resource. Sharing the
 * keys here keeps mutations and queries from drifting out of step when one is
 * invalidated and the other is read.
 */
export const CategoryQueryKeys = {
    all: ['categories'] as const,
    picker: () => [...CategoryQueryKeys.all, 'picker'] as const,
};
